import { Link } from "react-router-dom";
import { ArrowUp, ArrowUpRight, Linkedin, Mail, Phone } from "lucide-react";
import { useSite } from "@/lib/site";
import { Logo, NAV } from "./Header";

export const Footer = () => {
  const { settings } = useSite();
  if (!settings) return null;
  return (
    <footer data-testid="site-footer" className="relative border-t border-line/10 bg-canvas">
      <div className="container-x py-20 md:py-28">
        <p className="label-mono"><span className="text-gold">— </span>Let's talk</p>
        <Link to="/contact" data-testid="footer-cta-link" className="group mt-6 block max-w-5xl font-display text-5xl leading-[0.95] sm:text-6xl lg:text-8xl">
          Let's build what doesn't <em className="text-turq">exist yet</em>
          <ArrowUpRight className="ml-3 inline h-10 w-10 text-gold transition-transform duration-500 group-hover:rotate-45 lg:h-16 lg:w-16" aria-hidden />
        </Link>
        <div className="mt-20 grid gap-12 border-t border-line/10 pt-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-silver">{settings.footer_note}</p>
            <p className="mt-2 text-sm text-silver">{settings.location}</p>
          </div>
          <div className="md:col-span-3">
            <p className="label-mono mb-5">Navigate</p>
            <ul className="space-y-3 text-sm">
              {NAV.map((n) => (
                <li key={n.to}><Link to={n.to} data-testid={`footer-nav-${n.label.toLowerCase()}`} className="link-underline text-fg/90 hover:text-turq">{n.label}</Link></li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="label-mono mb-5">Contact</p>
            <ul className="space-y-3 text-sm">
              <li><a href={`mailto:${settings.contact_email}`} data-testid="footer-email-link" className="link-underline inline-flex items-center gap-2 break-all hover:text-turq"><Mail className="h-4 w-4 shrink-0 text-gold" aria-hidden />{settings.contact_email}</a></li>
              {settings.phone && (
                <li><a href={`tel:${settings.phone.replace(/[^\d+]/g, "")}`} data-testid="footer-phone-link" className="link-underline inline-flex items-center gap-2 hover:text-turq"><Phone className="h-4 w-4 shrink-0 text-gold" aria-hidden />{settings.phone}</a></li>
              )}
              <li><a href={settings.linkedin_url} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin-link" className="link-underline inline-flex items-center gap-2 hover:text-turq"><Linkedin className="h-4 w-4 text-gold" aria-hidden />LinkedIn</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-wrap items-center justify-between gap-4 text-xs text-silver">
          <p><Link to="/admin" data-testid="footer-admin-link" aria-label="Site administration" className="hover:text-fg">©</Link> {new Date().getFullYear()} {settings.name}. {settings.title}.</p>
          <button type="button" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} data-testid="footer-back-to-top" className="inline-flex items-center gap-2 hover:text-turq">
            Back to top <ArrowUp className="h-3.5 w-3.5" aria-hidden />
          </button>
        </div>
      </div>
    </footer>
  );
};
